import { AuthService } from '../service/auth.service';
import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpInterceptorFn,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError, delay, switchMap, take } from 'rxjs/operators';

import Swal from 'sweetalert2';
import { HelpersService } from '@shared/services/helpers.service';
import { Toast } from '@shared/constants';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NetworkStatusService } from '@core/service/network-status.service';
import { environment } from 'environments/environment';



export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
) => {
  const authenticationService = inject(AuthService);
  const router = inject(Router);
  const helperService = inject(HelpersService);
  const toastr = inject(ToastrService);
  const networkStatusService = inject(NetworkStatusService);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      console.log(err, 'err');
      const requestUrl = req.url;

      if (err.status === 0) {
         return EMPTY;
     }
     if (requestUrl.includes('realm')) {
      return throwError(() => err);
    }
      
      if (!req.url.includes('realm')) {
        if (!localStorage.getItem("currentUser")) {
      
          router.navigateByUrl('authentication/signin');
        }
        
        if(err.status === 401){
          toastr.error('Invalid session');
          authenticationService.logout();

          // setTimeout(() => {
          //   router.navigateByUrl('authentication/signin');
          // }, 2000);
          
          return EMPTY;
        }
      }

      const error =
      err?.error?.message ||
      err?.error?.error_description ||
      err?.statusText ||
      err?.error?.error_description;
      if (err.error.error_description  && err.error.error_description.includes('Session not active')) {
        helperService.showErrorToast('Session not active');
        authenticationService.logout();

      }
    if (err.status != 401 && 'errors' in err.error || Array.isArray(err.error)) {
      // helperService.showErrorToast(err.error?.title);
    
      if (err.status === 400) {
        const validationErrors = !Array.isArray(err.error) ? err.error.errors : err.error;
        console.error('Error refreshing token:', error);
        
        
        if (!Object.keys(validationErrors).includes('0')) {
          Object.keys(validationErrors).forEach((errField) => {
            if (validationErrors[errField]?.length > 0) {
              toastr.error(validationErrors[errField][0], errField);
            }
          });
        } else {
          validationErrors.forEach((errField: any) => {
            toastr.error(errField.error, errField.field);
          });
        }
      }
    } else {
      
      if (err.status === 401 && !req.url.includes('token')) {
        toastr.error('Unauthorized');
        authenticationService.logout();
    
        setTimeout(() => {
          router.navigateByUrl('authentication/signin');
        }, 2000);
        return EMPTY
      } else if (error !== 'OK') {
        toastr.error(error);
      }


    }
    
    // if (err.status === 400 && err.error != null) {
    //   if (err?.error?.error_description) {
    //     toastr.error(err?.error?.error_description);
    //   } else if (typeof err.error !== 'object' && error !== 'OK') {
    //     // toastr.error('', err.error); // Commented out line
    //   }
    // }

      return throwError(() => error);
    })
  );
};
